import { defineFcm } from '../shared/factory';

export const FCM_PSF_PROMOTE_OR_SHARE_SHARE_SLIDE_UP_ENABLED = defineFcm('psf_promote_or_share_share_slide_up_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'PSF Promote or Share page',
		description: 'Enables the share slide up on the PSF Promote or Share page in mobile devices.',
	});
